import React from "react";
import { Dialog } from "primereact/dialog";
import { ReactComponent as IconX } from "../../../assets/svg/icon-close.svg";

function StandardDialog({
  visible,
  onHide,
  header,
  closeDisabled = false,
  className,
  dismissableMask = true,
  modal = true,
  maskClassName = "dark-background",
  draggable = false,
  resizable = false,
  children,
  ...rest
}) {
  const close = () => {
    if (closeDisabled) {
      return;
    }

    if (typeof onHide === "function") {
      onHide();
    }
  };

  const maskClassNameFinal = String(maskClassName || "").trim();
  const resolvedMaskClassName = maskClassNameFinal.includes("dark-background")
    ? maskClassNameFinal
    : maskClassNameFinal
      ? `${maskClassNameFinal} dark-background`
      : "dark-background";

  return (
    <Dialog
      visible={visible}
      onHide={close}
      header={
        <>
          {header}
          <IconX
            className={closeDisabled ? "modal-close disabled-icon" : "modal-close"}
            onClick={close}
          />
        </>
      }
      className={className}
      modal={modal}
      dismissableMask={dismissableMask && !closeDisabled}
      maskClassName={resolvedMaskClassName}
      draggable={draggable}
      resizable={resizable}
      closable={false}
      {...rest}
    >
      {children}
    </Dialog>
  );
}

export default StandardDialog;
